export default __webpack_public_path__ + "static/media/button-small@3x.2621631c.png";